import React, { useState } from "react";

function MountainViewShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Junk Droid – South Bay Junk Pick Up & Hauling</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p className="resid-rmv">
          Looking for fast, reliable junk removal in the South Bay? Junk Droid
          has you covered! From Fremont to Cupertino, we’re your local go-to
          team for hauling away clutter from your home or business.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc milpitas-list">
            <p>
              Whether it’s old furniture, broken appliances, yard waste, or
              construction debris—if two people can lift it, we can take it. No
              heavy lifting required on your end—our crew does all the work so
              you don’t have to.
            </p>
            <p className="pt-0">
              Say goodbye to junk, and hello to a clean space. Just point, and
              Junk Droid handles the rest!
            </p>
            <h3>Free Estimate on Junk Removal in San Jose</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p>
              If you're ready to declutter your space, Junk Droid is here to
              help. Call us for a free onsite estimate or schedule your junk
              removal appointment online. We also offer free junk removal for
              qualifying items.
            </p>
            <p class="pt-0">
              Don’t wait! Call Junk Droid today for same-day junk removal or to
              get your free estimate on junk removal in San Jose, CA. Let us
              help you remove the unwanted junk from your life so you can have
              more space and peace of mind.
            </p>
            <h3>Contact Junk Droid for Junk Removal in San Jose, CA</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p>
              Call us at <a href="tel:+4085397261">(408) 539-7261</a> to
              schedule a junk removal service or get a free quote. Our
              professional team is ready to help with all your junk removal
              needs in San Jose, California and surrounding areas.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default MountainViewShowHide;
